module.exports = __webpack_public_path__ + "img/Washing_1200x800.8a109b65.png";